import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import {
  IAirlineBrand,
  IAirlineTaxes,
  IAirlineUserContactInfo,
  ICompany,
} from '@cai-services';
import { Gha } from './gha.model';
import { Rate } from './rate.model';
import { UldRate } from './uld-rate.model';

export interface RateGroup {
  airline?: string;
  commodity?: string;
  origin: string;
  destination: string;
  airlineCompanyIcon?: string;
  dataSource: MatTableDataSource<FakeData, MatPaginator>;
}

export class FakeData {
  id: number;
  origin: string;
  otherSurcharges?: number;
  freight?: number;
  total?: number;
  originAirportName: string;
  destination: string;
  destinationAirportName: string;
  commodity: string;
  airlineProdCode?: string;
  airlineRateRemarks?: string;
  aircraftTypes: string;
  shcs?: string;
  density: string;
  originalFreightTotal?: number;
  originalFreightAmount?: number;
  flightNo: string;
  day: string;
  dayOff?: boolean;
  iatacass: string;
  uldType: string;
  startDate: Date;
  endDate: Date;
  lastUpdatedDate: Date;
  currency: string;
  fuelSurcharge: number;
  securitySurcharge: number;
  miscellaneousCharge: number;
  saf: number;
  rfsRemarks?: string;
  freightAmount?: number;
  freightSurcharge?: string;
  freightTotal?: number;
  airlineCompanyCode: string;
  airlineCompanyName: string;
  airlineCompanyIcon: string;
  forwarderOfficeName: string;
  rates: Rate[];
  uldRate: UldRate;
  gha?: Gha;
  isGhaDownloadButtonHovered: boolean;
  type: string;
  airlineUserContactInfo?: IAirlineUserContactInfo[];
  airlineBrand: IAirlineBrand;
  taxes?: IAirlineTaxes;
  gsaCompany?: ICompany;
}
